var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7294_89890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.76953 14C8.8741 14 9.76953 13.1046 9.76953 12C9.76953 10.8954 8.8741 10 7.76953 10C6.66496 10 5.76953 10.8954 5.76953 12C5.76953 13.1046 6.66496 14 7.76953 14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7695 12C14.7695 13.1046 13.8741 14 12.7695 14C11.6649 14 10.7695 13.1046 10.7695 12C10.7695 10.8954 11.6649 10 12.7695 10C13.8741 10 14.7695 10.8954 14.7695 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7695 14C18.8741 14 19.7695 13.1046 19.7695 12C19.7695 10.8954 18.8741 10 17.7695 10C16.6649 10 15.7695 10.8954 15.7695 12C15.7695 13.1046 16.6649 14 17.7695 14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7695 12C24.7695 18.6274 19.3969 24 12.7695 24C6.14211 24 0.769531 18.6274 0.769531 12C0.769531 5.37258 6.14211 0 12.7695 0C19.3969 0 24.7695 5.37258 24.7695 12ZM22.7695 12C22.7695 17.5228 18.2923 22 12.7695 22C7.24668 22 2.76953 17.5228 2.76953 12C2.76953 6.47715 7.24668 2 12.7695 2C18.2923 2 22.7695 6.47715 22.7695 12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7294_89890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.769531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherLink);
export default __webpack_public_path__ + "static/media/other-link.8e885e417ac929b4dd3ba235610b020e.svg";
export { ForwardRef as ReactComponent };